import React from 'react';
import styled from 'styled-components';
import { FaWhatsapp, FaPhone, FaEnvelope } from 'react-icons/fa';

const OptionsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
  margin: 0.5rem 0;
`;

const OptionButton = styled.button`
font-family: 'Times New Roman', serif;
  background: ${props => {
    if (props.whatsapp) return '#25D366';
    if (props.phone) return '#3730A3';
    if (props.email) return '#EA4335';
    return '#f0efff';
  }};
  color: ${props => props.whatsapp || props.phone || props.email ? 'white' : '#3730A3'};
  border: none;
  padding: 0.4rem 1rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: ${props => props.whatsapp ? '600' : '500'};
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.3rem;
  border: 1px solid ${props => props.whatsapp ? '#25D366' : props.phone ? '#3730A3' : props.email ? '#EA4335' : '#d0d0e0'};
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1);
    background: ${props => {
      if (props.whatsapp) return '#20b859';
      if (props.phone) return '#0b0b77';
      if (props.email) return '#d03c2f';
      return '#e0d8f0';
    }};
  }
`;

const ChatOptions = ({ options, onSelect, onWhatsApp }) => {
  return (
    <OptionsContainer>
      {options.map((option, index) => {
        if (option === "💬 WhatsApp Chat" || option === "💬 WhatsApp") {
          return (
            <OptionButton key={index} whatsapp onClick={() => onWhatsApp()}>
              <FaWhatsapp size={12} /> {option.replace("💬 ", "")}
            </OptionButton>
          );
        }
        
        if (option.includes("📞")) {
          return (
            <OptionButton key={index} phone onClick={() => onSelect(option)}>
              <FaPhone size={10} /> {option.replace("📞 ", "")}
            </OptionButton>
          );
        }
        
        if (option.includes("📧")) {
          return (
            <OptionButton key={index} email onClick={() => onSelect(option)}>
              <FaEnvelope size={10} /> {option.replace("📧 ", "")}
            </OptionButton>
          );
        }
        
        return (
          <OptionButton key={index} onClick={() => onSelect(option)}>
            {option}
          </OptionButton>
        );
      })}
    </OptionsContainer>
  );
};

export default ChatOptions;